import React from 'react';
import { Link } from 'react-router-dom';
import { useSiteData } from '../../context/SiteDataContext';

const E85Section = () => {
  const { pageContent } = useSiteData();
  const c = pageContent?.e85 || {};
  const stats = c.stats || [
    { value: '-45%', label: 'Économies carburant' },
    { value: '+10%', label: 'Puissance' },
    { value: '-50%', label: 'Émissions CO2' },
  ];

  return (
    <section className="min-h-screen w-full bg-black flex items-center relative overflow-hidden" data-testid="e85-section">
      <div className="absolute inset-0 bg-cover bg-center opacity-30" style={{ backgroundImage: `url(${c.bgImage || 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=1920'})` }} />
      <div className="absolute inset-0 bg-gradient-to-b from-black via-black/80 to-black" />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16 sm:py-20">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block text-green-400 text-xs sm:text-sm font-medium uppercase tracking-[0.2em] mb-4 sm:mb-6">{c.category || 'Flex-fuel'}</span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-6 leading-tight">
            {c.title || 'E85 : Plus vert,'} <span className="text-green-400">{c.titleAccent || 'moins cher'}</span>
          </h2>
          <p className="text-white/60 text-sm sm:text-base lg:text-lg leading-relaxed mb-8 sm:mb-12 max-w-2xl mx-auto">
            {c.desc || ''}
          </p>

          <div className="grid grid-cols-3 gap-4 sm:gap-8 mb-8 sm:mb-12">
            {stats.map((stat, i) => (
              <div key={i} className="text-center">
                <div className="text-2xl sm:text-4xl md:text-5xl font-bold text-green-400 mb-1 sm:mb-2">{stat.value}</div>
                <div className="text-white/50 text-[10px] sm:text-sm uppercase tracking-wider">{stat.label}</div>
              </div>
            ))}
          </div>

          <Link to={c.ctaLink || '/reprogrammation'} data-testid="e85-cta" className="group inline-flex items-center gap-3 bg-green-600 hover:bg-green-700 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-medium transition-all duration-300 text-sm sm:text-base">
            <span>{c.ctaText || 'Roulez au bioéthanol'}</span>
            <svg className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" /></svg>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default E85Section;
